<img [alt]='alt'
     [src]="imgUrl | async"/>
